import { API } from 'api'
import {
	AddNewTagResponse,
	FiltersDynamicListRequest,
	MessageResponse,
	PeopleTagsOrgRequest,
	StaticListRequest,
	TagDynamicListRequest,
	UploadFileCSVBody
} from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils/sentry'

export const addStaticList = async (
	organizationId: number,
	body: StaticListRequest
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.post(`/people/static_list/organization/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.ADD_STATIC_LIST_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const addNewTag = async (
	organizationId: number,
	body: PeopleTagsOrgRequest
): Promise<AddNewTagResponse | null> => {
	let res = null
	await API()
		.post(`/people/tag/organization/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.ADD_NEW_TAG_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const addTagDynamicList = async (
	organizationId: number,
	body: TagDynamicListRequest
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.post(`/people/tag/dynamic_list/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.ADD_TAG_DYNAMIC_LIST_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const addFiltersDynamicList = async (
	organizationId: number,
	body: FiltersDynamicListRequest
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.post(`people/tag/dynamic_list/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const editFiltersDynamicList = async (
	organizationId: number,
	id: number,
	body: FiltersDynamicListRequest
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.patch(`/people/dynamic_list/${id}/organization/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.EDIT_FILTERS_DYNAMIC_LIST_ERROR,
					error,
					extra: {
						payload: body,
						organizationId,
						id
					}
				})
				console.warn('Error:', error.message)
			}
		)
	return res
}

export const importUsersCSV = async (
	organizationId: number,
	body: UploadFileCSVBody
): Promise<MessageResponse | null> => {
	let res = null
	await API()
		.post(`/people/import_users/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.warn('Error:', error.message)
			}
		)
	// eslint-disable-next-line no-console
	console.log('🚀 ~ res:', res)
	return res
}
